var swiper = new Swiper(".swiperPress", {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        slidesPerView: "auto",
        allowTouchMove: false,
        centeredSlides: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        speed: 6000,
        breakpoints: {
          750: {
            slidesPerView: 3,
            loop: true,
            spaceBetween: 40,
            speed: 8000,
          },
          990: {
            slidesPerView: 3.5,
            loop: true,
            spaceBetween: 40,
            speed: 10000,
          },
        }
      });